import { defineComponent as _defineComponent } from 'vue'
import {
  NavBar,
  HeadingDisplay,
  ButtonContainer,
  ButtonPrimary,
  ContentDisplay,
  LoaderIndicator,
  HelperViewStatus,
  Row,
  InitialAvatarIcon
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { useRoute, useRouter } from 'vue-router/composables';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { TedSection, PixSection, PixSectionModal } from './components';
import { getPixInfo } from '@/modules/cash/services/cash';
import type { IPixInfo } from '@/modules/cash/services/cash';
import { pixES } from '@/modules/cash/services/sse';
import type { IDepositMethodSection, IPixRequestMessage } from './types';
import { headerTexts } from './texts';
import { tradeModule } from '@/modules/trade/store/trade';
import {
  ICustomerBankAccountResponse,
  getCustomerBankAccount,
  getNewCustomerBankAccount
} from '@/modules/transaction/services/new-deposit';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';


export default /*#__PURE__*/_defineComponent({
  __name: 'Deposit',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const messageData = ref<IPixRequestMessage['message'] | null>(null);
const hasError = ref(false);
const isLoading = ref(true);
const depositInfo = ref<
  ICustomerBankAccountResponse['bankAccount'] | IPixInfo | null
>(null);
const isOpenModal = ref(false);
const copyButtonLabel = ref('Copiar dados');

const eventSource = pixES();

eventSource.onerror = ev => {
  eventSource.close();
  console.error(ev);
};

eventSource.onmessage = (event: MessageEvent) => {
  const eventData = JSON.parse(event.data);
  if (eventData.message) {
    messageData.value = eventData.message as IPixRequestMessage['message'];
    isOpenModal.value = true;
  }
};

const depositMethod = computed(() => route.meta!.depositMethod);

const staticTexts =
  depositMethod.value === 'ted' ? headerTexts.ted : headerTexts.pix;

const copyAccountNumber = async () => {
  try {
    const { account } =
      depositInfo.value as ICustomerBankAccountResponse['bankAccount'];
    await navigator.clipboard.writeText(account);
    copyButtonLabel.value = 'Copiado!';
  } catch (e) {
    console.error(e);
  } finally {
    setTimeout(() => {
      copyButtonLabel.value = 'Copiar dados';
    }, 2000);
  }
};

async function fetchDepositInfo() {
  try {
    hasError.value = false;
    isLoading.value = true;
    await fetchRequest();
  } catch (e) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

async function fetchRequest() {
  if (depositMethod.value === 'ted') {
    depositInfo.value = (await getBankAccount()).bankAccount;
  } else {
    depositInfo.value = await getPixInfo();
  }
}

async function getBankAccount() {
  const shouldUseNewRoute = FeatureFlagsModule.isEnabled(
    FeatureFlags.ENABLE_BFF_BANKING_MIGRATION
  );

  if (shouldUseNewRoute) {
    return await getNewCustomerBankAccount();
  } else {
    return await getCustomerBankAccount();
  }
}

function getDepositMethodSection(): IDepositMethodSection {
  if (depositMethod.value === 'ted')
    return {
      component: TedSection,
      prop: 'deposit-information',
      value: depositInfo.value as ICustomerBankAccountResponse['bankAccount']
    };
  return {
    component: PixSection,
    prop: 'pix-info',
    value: depositInfo.value as IPixInfo
  };
}

function closeModal() {
  isOpenModal.value = false;
}

function goToTedView() {
  router.push({ name: 'deposit-ted' });
}

onMounted(async () => {
  await fetchDepositInfo();
  await tradeModule.fetchStatus();
});

onUnmounted(() => {
  eventSource.close();
});

return { __sfc: true,route, router, messageData, hasError, isLoading, depositInfo, isOpenModal, copyButtonLabel, eventSource, depositMethod, staticTexts, copyAccountNumber, fetchDepositInfo, fetchRequest, getBankAccount, getDepositMethodSection, closeModal, goToTedView, NavBar, HeadingDisplay, ButtonContainer, ButtonPrimary, ContentDisplay, LoaderIndicator, HelperViewStatus, Row, InitialAvatarIcon, BackButton, PixSectionModal }
}

})